<div class="flex justify-between pl-4">
  <h1>Policies</h1>
<!-- <lib-button [cssType]="'btn-secondary'"  [text]="'Export'" [size]="'small'"  (click)="exportGrid()"></lib-button>>-->
</div>
<lib-ui-grid [(gridOptions)]="gridOptions" (actionEvent)="actionEvent($event)"></lib-ui-grid>